export default {
    eventData: "Veranstaltungsdaten",
    event: "Veranstaltung",
    date: "Datum",
    organizer: "Veranstalter",
    mail: "Veranstalter E-Mail",
    phone: "Veranstalter Telefon",
    responsibleEmployee: "Verantwortlicher Mitarbeiter",
    responsibleEmployeeEmail: "E-Mail",
    responsibleEmployeePhone: "Telefon",
    responsibleEmployeeContactHours: "Kontaktzeiten",
    deposit: "Anzahlung",
    dueDateDeposit: "innerhalb von {days} Tagen ab Rechnungsdatum",
    dueDateRemainingAmount: "Der Restbetrag ist fällig zum {date}",
    dueDateRemainingAmountInDays: "Der Restbetrag wird {days} Tagen nach Rechnungsdatum fällig",
    invoiceRecipient: "Rechnungsempfänger",
    contactPerson: "Ansprechperson",
    participants: "Teilnehmende",
    caregivers: "Betreuende",
    persons: "Personen",
    paymentType: "Zahlungsart",
    priceOverview: "Preisübersicht",
    comments: "Möchten Sie uns noch etwas mitteilen?",
    finishGroupRegistration: "Gruppenanmeldung abschließen",
    finishGroupBuy: "Gruppenbestellung abschließen",
    finishGroupRegistrationExplanation: "Wenn Sie die Gruppenanmeldung abschließen sind keine weiteren Anmeldungen mehr möglich.",
    finishGroupBuyExplanation: "Wenn Sie die Gruppenbestellung abschließen sind keine weiteren Bestellungen mehr möglich.",
    terms: "Bedingungen",
    state: 'Status',

    // Registration states
    states: {
        abgesend: 'Neu',
        bearbtt: 'Bearbeitet',
        laufendegruppe: 'Laufende Gruppenanmeldung',
        Ende: 'Abgeschlossen',
    },

    and: "und",

    participantTerms: "Teilnahmebedingungen",
    privacy: "Datenschutzerklärung",

    preContractualInfo: "Vorvertragliche Informationen",

    termsStart: "Ich erkenne die ",
    participationTermsOfOrganizer: "Teilnahmebedingungen des Veranstalters",
    termsAnd: " und die ",
    privacyAgreement: "Datenschutzerklärung",
    termsEnd: " als verbindlich an. Weiterhin erkläre ich, für die vertraglichen Verpflichtungen einzustehen sowie den Gesamtpreis zu schulden. Die vorstehenden Anerkenntnisse und Ermächtigungen gelten auch für alle Gebühren, die gemäß den Vertragsbedingungen bei einer Vertragsänderung entstehen.",


    preContractualInfoStart: "Das ",
    preContractualInfoOfOrganizer1: "Informationsblatt ",
    preContractualInfoOfOrganizer2: "„Vorvertragliche Informationen Ihres Reiseveranstalters zu Ihrer Pauschalreise“",
    preContractualInfoAnd: " und das ",
    moreInformationAboutYourRightsPart1: "Formblatt zur ",
    moreInformationAboutYourRightsPart2: "„Unterrichtung des Reisenden mit weiterführenden Informationen zu Ihren wichtigsten Rechten nach der Richtlinie (EU) 2015/2302“",
    moreInformationAboutYourRightsPart3: " nach § 651a BGB",
    preContractualInfoEnd: " habe ich erhalten.",

    packageTourInfo: "Bei der Ihnen angebotenen Kombination von Reiseleistungen handelt es sich um eine Pauschalreise im Sinne der Richtlinie (EU) 2015/2302. Daher können Sie alle EU-Rechte in Anspruch nehmen, die für Pauschalreisen gelten.",
    asteriskExplanation: "Die mit * markierten Optionen müssen ausgewählt werden."
}
